import { render, staticRenderFns } from "./StatsTable.vue?vue&type=template&id=3bb901a0&"
import script from "./StatsTable.vue?vue&type=script&lang=js&"
export * from "./StatsTable.vue?vue&type=script&lang=js&"
import style0 from "./StatsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
installComponents(component, {VProgressLinear,VSelect,VSimpleTable})
